import { trackEvent } from '../commonTracking';

export const qrTrack = (data) => {
  try {
    trackEvent('QR SCAN', { hitName: 'QR SCAN', ...data });
  } catch (error) {
    console.log(error);
  }
};

export const dynamicQrTrack = (data) => {
  try {
    trackEvent('DYNAMIC_QR', { hitName: 'DYNAMIC_QR', ...data });
  } catch (error) {
    console.log(error);
  }
};
